import { render, staticRenderFns } from "./wash.vue?vue&type=template&id=f139f93e&scoped=true&"
import script from "./wash.vue?vue&type=script&lang=js&"
export * from "./wash.vue?vue&type=script&lang=js&"
import style0 from "./wash.vue?vue&type=style&index=0&id=f139f93e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f139f93e",
  null
  
)

export default component.exports